import { render, staticRenderFns } from "./OverallAssessmentFooter.vue?vue&type=template&id=42802e23"
import script from "./OverallAssessmentFooter.vue?vue&type=script&lang=ts"
export * from "./OverallAssessmentFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports